<template>
  <div class="wf-node-wrap">
    <!-- 节点卡片 -->
    <div class="wf-node" :class="node.type">
      <div class="wf-node-card" @click="onClickCard">
        <div class="wf-node-head">
          <i :class="headIcon"></i>
          <span class="wf-node-name">{{ displayName }}</span>
          <i
            v-if="removable"
            class="el-icon-close wf-node-close"
            @click.stop="wfDesigner.removeNode(node, parent, branch)"
          ></i>
        </div>
        <div class="wf-node-summary" v-if="node.type === 'approval' || node.type === 'cc'">
          <span>{{ assigneeText }}</span>
          <el-tag v-if="node.type === 'approval'" size="mini" effect="plain" type="info">{{ modeText }}</el-tag>
        </div>
        <div class="wf-node-summary" v-else-if="node.type === 'branch'">
          <span>{{ (node.branches || []).length }} 个条件分支</span>
        </div>
      </div>

      <!-- 分支：横向并列 -->
      <div v-if="node.type === 'branch'" class="wf-branch-box">
        <div class="wf-branch-add-top" @click="wfDesigner.addBranch(node)"><span>+ 添加分支</span></div>
        <div class="wf-branch-cols">
          <div class="wf-branch-col" v-for="(b, i) in node.branches" :key="i">
            <i class="wf-col-top"></i>
            <div class="wf-branch-head" @click="wfDesigner.openBranchConfig(node, b, i)">
              <span class="wf-branch-name">{{ b.name || ('分支' + (i + 1)) }}</span>
              <i class="el-icon-close" @click.stop="wfDesigner.removeBranch(node, i)"></i>
            </div>
            <div class="wf-branch-cond">{{ conditionText(b) }}</div>
            <!-- 分支子链 -->
            <node-wrap
              v-if="b.child"
              :node="b.child"
              :branch="b"
              :depth="depth + 1"
            />
            <!-- 仅空分支显示列底添加按钮；非空链路由末节点的“+”负责追加，避免两个“+”重叠 -->
            <div class="wf-branch-add" v-if="!b.child">
              <el-dropdown trigger="click" @command="t => wfDesigner.insertIntoBranch(b, t)">
                <span class="wf-add-btn">+</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="approval">审批人</el-dropdown-item>
                  <el-dropdown-item command="cc">抄送人</el-dropdown-item>
                  <el-dropdown-item command="branch">条件分支</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <i class="wf-col-stub"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- 节点后的插入按钮 -->
    <div class="wf-add-line" v-if="node.type !== 'end'">
      <el-dropdown trigger="click" @command="t => wfDesigner.insertAfter(node, t)">
        <span class="wf-add-btn">+</span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="approval">审批人</el-dropdown-item>
          <el-dropdown-item command="cc">抄送人</el-dropdown-item>
          <el-dropdown-item command="branch">条件分支</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 递归渲染 child -->
    <node-wrap
      v-if="node.child"
      :node="node.child"
      :parent="node"
      :depth="depth + 1"
    />
  </div>
</template>

<script>
const ASSIGNEE_LABEL = {
  user: '指定人员', role: '指定角色', deptLeader: '部门负责人',
  initiatorLeader: '直属上级', form: '表单指定', formDeptLeader: '表单人员部门负责人', self: '发起人自选'
}

export default {
  name: 'NodeWrap',
  inject: ['wfDesigner'],
  props: {
    node: { type: Object, required: true },
    parent: { type: Object, default: null },
    branch: { type: Object, default: null },
    depth: { type: Number, default: 0 }
  },
  computed: {
    removable() {
      return this.node.type !== 'start' && this.node.type !== 'end'
    },
    displayName() {
      if (this.node.type === 'start') return '发起人'
      if (this.node.type === 'end') return '流程结束'
      return (this.node.props && this.node.props.name) || this.defaultName
    },
    defaultName() {
      return { approval: '审批人', cc: '抄送人', branch: '条件分支' }[this.node.type] || '节点'
    },
    headIcon() {
      return {
        start: 'el-icon-user-solid', approval: 'el-icon-s-check',
        cc: 'el-icon-message-solid', branch: 'el-icon-share', end: 'el-icon-flag'
      }[this.node.type] || 'el-icon-more'
    },
    assigneeText() {
      const p = this.node.props || {}
      let base = ASSIGNEE_LABEL[p.assigneeType] || '未设置审批人'
      if ((p.assigneeType === 'user' || p.assigneeType === 'role') && p.assigneeValue && p.assigneeValue.length) {
        base += '(' + p.assigneeValue.length + ')'
      }
      return base
    },
    modeText() {
      const m = this.node.props && this.node.props.approveMode
      return m === 'and' ? '会签' : '或签'
    }
  },
  methods: {
    onClickCard() {
      if (this.node.type === 'branch') return
      this.wfDesigner.openConfig(this.node)
    },
    conditionText(b) {
      if (!b.condition || !b.condition.rules || !b.condition.rules.length) return '默认分支(其它情况)'
      const logic = (b.condition.logic || 'and') === 'or' ? ' 或 ' : ' 且 '
      return b.condition.rules.map(r => `${r.field} ${r.op} ${r.value == null ? '' : r.value}`).join(logic)
    }
  }
}
</script>

<style scoped>
.wf-node-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wf-node {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wf-node-card {
  width: 220px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #EBEEF5;
  border-top: 3px solid #C0C4CC;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  overflow: hidden;
}
.wf-node-card:hover {
  box-shadow: 0 4px 14px rgba(64, 158, 255, 0.2);
}
.wf-node.approval .wf-node-card { border-top-color: #409EFF; }
.wf-node.cc .wf-node-card { border-top-color: #E6A23C; }
.wf-node.branch .wf-node-card { border-top-color: #67C23A; }
.wf-node.start .wf-node-card, .wf-node.end .wf-node-card { border-top-color: #909399; }
.wf-node-head {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
}
.wf-node.approval .wf-node-head { background: #409EFF; }
.wf-node.cc .wf-node-head { background: #E6A23C; }
.wf-node.branch .wf-node-head { background: #67C23A; }
.wf-node.start .wf-node-head, .wf-node.end .wf-node-head { background: #909399; }
.wf-node-head i { margin-right: 6px; }
.wf-node-name { flex: 1; }
.wf-node-close { cursor: pointer; opacity: 0.85; }
.wf-node-summary {
  padding: 8px 12px;
  font-size: 12px;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}
.wf-add-line {
  height: 40px;
  display: flex;
  align-items: center;
  position: relative;
}
.wf-add-line::before {
  content: '';
  position: absolute;
  top: 0; bottom: 0; left: 50%;
  width: 2px;
  background: #DCDFE6;
  z-index: 0;
}
.wf-add-btn {
  width: 22px;
  height: 22px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
  background: #409EFF;
  color: #fff;
  cursor: pointer;
  z-index: 1;
  font-size: 16px;
  user-select: none;
}
.wf-branch-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wf-branch-add-top {
  position: relative;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.wf-branch-add-top::before {
  content: '';
  position: absolute;
  top: 0; bottom: 0; left: 50%;
  width: 2px;
  background: #DCDFE6;
  transform: translateX(-50%);
}
.wf-branch-add-top span {
  position: relative;
  z-index: 1;
  background: #F5F7FA;
  padding: 0 6px;
  color: #409EFF;
  font-size: 12px;
}
.wf-branch-cols {
  display: flex;
  align-items: stretch;
}
.wf-branch-col {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 220px;
  padding: 0 10px;
}
/* 分支上/下汇合横线：首列画右半、末列画左半、中间列画满，拼接成连续横线 */
.wf-branch-col::before,
.wf-branch-col::after {
  content: '';
  position: absolute;
  height: 2px;
  background: #DCDFE6;
  left: 0;
  right: 0;
}
.wf-branch-col::before { top: 0; }
.wf-branch-col::after { bottom: 0; }
.wf-branch-col:first-child::before,
.wf-branch-col:first-child::after { left: 50%; }
.wf-branch-col:last-child::before,
.wf-branch-col:last-child::after { right: 50%; }
.wf-branch-col:only-child::before,
.wf-branch-col:only-child::after { display: none; }
/* 分支列顶部短竖线(接上汇合线)与底部伸缩竖线(接下汇合线) */
.wf-col-top { width: 2px; height: 12px; background: #DCDFE6; flex: none; }
.wf-col-stub { width: 2px; flex: 1 0 12px; background: #DCDFE6; }
.wf-branch-head {
  background: #F0F9EB;
  border: 1px solid #67C23A;
  color: #67C23A;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}
.wf-branch-cond {
  font-size: 11px;
  color: #909399;
  margin: 4px 0;
  max-width: 220px;
  text-align: center;
}
.wf-branch-add { margin-top: 6px; }
</style>
